(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animation-player"] && !Shopify.designMode) return;
  try {
    
/* Animation Player */
const video = document.querySelector(".scroll-video");

ScrollTrigger.create({
  trigger: video,
  start: "top 80%", // When the top of the video reaches 80% of the viewport
  end: "bottom 20%", // When the bottom reaches 20% of the viewport

  onEnter: () => video.play(),
  onEnterBack: () => video.play(),

  onLeave: () => video.pause(),
  onLeaveBack: () => video.pause()
});

  } catch(e) { console.error(e); }
})();
})();
